import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { editRouteRef, rootRouteRef } from './routes';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import {
  ApiBlueprint,
  createFrontendPlugin,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { confluentApiRef } from './api';
import {
  confluentPermission,
  DefaultApiClient,
} from '@internal/plugin-confluent-common';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { RiTelegramLine } from '@remixicon/react';

const confluentPage = PageBlueprint.make({
  name: 'list',
  params: {
    title: 'Confluent Cloud',
    path: '/confluent',
    routeRef: convertLegacyRouteRef(rootRouteRef),
    icon: <RiTelegramLine />,
    loader: () =>
      import('./components/ConnectorComponent/').then(m =>
        // TODO: Is this the correct way to setup RequirePermission for a page ?
        // Waiting for response on Discord question for this one.
        compatWrapper(
          <RequirePermission permission={confluentPermission}>
            <m.ConnectorComponent />
          </RequirePermission>,
        ),
      ),
  },
});

// TODO: Why is it not possible to export eaach page as seperate PageBlueprints ?
// const confluentEditPage = PageBlueprint.make({
//   name: 'edit',
//   params: {
//     path: '/edit/:name',
//     routeRef: convertLegacyRouteRef(editRouteRef),
//     loader: () =>
//       import('./components/ConnectorListComponent').then(m =>
//         compatWrapper(<m.ConnectListComponent />),
//       ),
//   },
// });
//
// const confluentEditPage = PageBlueprint.make({
//   name: 'edit',
//   params: {
//     path: '/edit/:name',
//     routeRef: convertLegacyRouteRef(editRouteRef),
//     loader: () =>
//       import('./components/ConnectorListComponent').then(m =>
//         compatWrapper(<m.ConnectListComponent />),
//       ),
//   },
// });

const confluentApi = ApiBlueprint.make({
  name: 'confluent',
  params: defineParams =>
    defineParams({
      api: confluentApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DefaultApiClient({ discoveryApi, fetchApi }),
    }),
});

export const confluentPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'confluent',
  info: {
    // Load plugin info from package json
    packageJson: () => import('../package.json'),
  },
  // bind all the extensions to the plugin
  extensions: [confluentApi, confluentPage],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
    edit: editRouteRef,
  }),
});
